import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class ProjectSurveySearchParams extends SearchParamsBase {
  constructor(clientId) {
    super();
    if (clientId !== undefined) {
      this.ClientId = clientId.toString();
    }
  }

  initialize() {
    this.IsActive = '';
    this.ClientId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'ProjectSurveySearchParams';
}
